// @ts-check
import {
  collection,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
  query,
  where,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { db } from "./firebase_db";
import { getEmail } from "../firebase_auth";

/**
 * @import { ProjectUser } from "./project_user";
 * @import { Unsubscriber } from "./unsubscriber";
 */

export const project_users = collection(db, "project_users");

/**
 * @param {ProjectUser} pu
 */
export async function saveProjectUser(pu) {
  const ref = doc(project_users, `${pu.project}<->${pu.user}`);
  await setDoc(ref, pu);
}

/**
 * @param {ProjectUser} pu
 */
export async function removeProjectUser(pu) {
  const ref = doc(project_users, `${pu.project}<->${pu.user}`);
  await deleteDoc(ref);
}

/**
 * @param {string} project
 * @returns {Promise<ProjectUser?>}
 */
export async function getProjectUser(project) {
  const email = getEmail();
  const ref = doc(project_users, `${project}<->${email}`);
  const d = await getDoc(ref);
  if (!d.exists()) return null;
  /** @type {any} */
  const data = d.data();
  return data;
}

/**
 * @param {string} project
 * @param {(pu: ProjectUser?) => void} onChange
 * @returns {Promise<Unsubscriber>}
 */
export async function subscribeProjectUser(project, onChange) {
  const email = getEmail();
  const ref = doc(project_users, `${project}<->${email}`);
  const unsubscribe = onSnapshot(ref, (doc) => {
    /** @type {any} */
    const data = doc.data();
    onChange(data);
  });
  return {
    invoke: () => unsubscribe(),
  };
}

/**
 * @param {string} project
 * @returns {Promise<ProjectUser[]>}
 */
export async function getProjectUsers(project) {
  const filter = where("project", "==", project);
  const q = query(project_users, filter);
  const docs = await getDocs(q);
  const projectUsers = [];
  docs.forEach((doc) => {
    projectUsers.push(doc.data());
  });
  return projectUsers;
}

/**
 * @param {string} user
 * @returns {Promise<ProjectUser[]>}
 */
export async function getUserProjects(user) {
  const filter = where("user", "==", user);
  const q = query(project_users, filter);
  const docs = await getDocs(q);
  const projectUsers = [];
  docs.forEach((doc) => {
    projectUsers.push(doc.data());
  });
  return projectUsers;
}
